import { Footer } from '@/components/Footer'
import { TranslateView } from '@/features/translate/TranslateView'

export default function App() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col px-5 py-10 sm:px-8 sm:py-16">
      <main className="flex-1">
        <TranslateView />
      </main>
      <Footer />
    </div>
  )
}
